/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Activity = {
  __typename?: 'Activity';
  bid?: Maybe<Bid>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  tradeCompany: TradeCompany;
  type: TradeActivityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges?: Maybe<Array<ActivityEdge>>;
  pageInfo?: Maybe<ActivityPageInfo>;
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Activity>;
};

export type ActivityInput = {
  bid?: InputMaybe<BidInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityListResponse = {
  __typename?: 'ActivityListResponse';
  data: Array<Activity>;
  pageData?: Maybe<PageData>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  trade?: Maybe<Trade>;
  type: ActivityLogType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type ActivityLogConnection = {
  __typename?: 'ActivityLogConnection';
  edges?: Maybe<Array<ActivityLogEdge>>;
  pageInfo?: Maybe<ActivityLogPageInfo>;
};

export type ActivityLogEdge = {
  __typename?: 'ActivityLogEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ActivityLog>;
};

export type ActivityLogListResponse = {
  __typename?: 'ActivityLogListResponse';
  data: Array<ActivityLog>;
  pageData?: Maybe<PageData>;
};

export type ActivityLogPageInfo = {
  __typename?: 'ActivityLogPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ActivityLogRelayResponse = {
  __typename?: 'ActivityLogRelayResponse';
  page: ActivityLogConnection;
  pageData?: Maybe<PageData>;
};

export enum ActivityLogType {
  BaseTermsUpdated = 'BASE_TERMS_UPDATED',
  BidAwarded = 'BID_AWARDED',
  BidDeclined = 'BID_DECLINED',
  BidExpired = 'BID_EXPIRED',
  BidReceived = 'BID_RECEIVED',
  BidRejected = 'BID_REJECTED',
  BidSent = 'BID_SENT',
  BidWithdrawn = 'BID_WITHDRAWN',
  CompanyActivated = 'COMPANY_ACTIVATED',
  CompanyCreated = 'COMPANY_CREATED',
  CompanyDeactivated = 'COMPANY_DEACTIVATED',
  CompanyDeleted = 'COMPANY_DELETED',
  CompanyUpdated = 'COMPANY_UPDATED',
  CounterpartyAddedToTrade = 'COUNTERPARTY_ADDED_TO_TRADE',
  DealConfirmed = 'DEAL_CONFIRMED',
  DocumentAddedToTrade = 'DOCUMENT_ADDED_TO_TRADE',
  DocumentDeleted = 'DOCUMENT_DELETED',
  DocumentEdited = 'DOCUMENT_EDITED',
  DraftTermSheetReceived = 'DRAFT_TERM_SHEET_RECEIVED',
  DraftTermSheetSent = 'DRAFT_TERM_SHEET_SENT',
  DraftTradeCreated = 'DRAFT_TRADE_CREATED',
  DraftTradeDeleted = 'DRAFT_TRADE_DELETED',
  DraftTradeUpdated = 'DRAFT_TRADE_UPDATED',
  MessageAll = 'MESSAGE_ALL',
  MessageReceived = 'MESSAGE_RECEIVED',
  MessageSent = 'MESSAGE_SENT',
  OfferAwarded = 'OFFER_AWARDED',
  OfferDeclined = 'OFFER_DECLINED',
  OfferExpired = 'OFFER_EXPIRED',
  OfferReceived = 'OFFER_RECEIVED',
  OfferRejected = 'OFFER_REJECTED',
  OfferSent = 'OFFER_SENT',
  OfferWithdrawn = 'OFFER_WITHDRAWN',
  PasswordChanged = 'PASSWORD_CHANGED',
  PasswordResetRequested = 'PASSWORD_RESET_REQUESTED',
  RoleCreated = 'ROLE_CREATED',
  RoleUpdated = 'ROLE_UPDATED',
  TemplateCreated = 'TEMPLATE_CREATED',
  TemplateDeleted = 'TEMPLATE_DELETED',
  TemplatePublished = 'TEMPLATE_PUBLISHED',
  TemplateUpdated = 'TEMPLATE_UPDATED',
  TermsheetreviewCommented = 'TERMSHEETREVIEW_COMMENTED',
  TermsheetreviewDeclined = 'TERMSHEETREVIEW_DECLINED',
  TermsheetreviewRequested = 'TERMSHEETREVIEW_REQUESTED',
  TermsheetreviewReverted = 'TERMSHEETREVIEW_REVERTED',
  TermsheetreviewSupported = 'TERMSHEETREVIEW_SUPPORTED',
  TermsheetExported = 'TERMSHEET_EXPORTED',
  TradeApproved = 'TRADE_APPROVED',
  TradeClosed = 'TRADE_CLOSED',
  TradeConsiderationEndTimeChanged = 'TRADE_CONSIDERATION_END_TIME_CHANGED',
  TradeDeleted = 'TRADE_DELETED',
  TradeEndTimeChanged = 'TRADE_END_TIME_CHANGED',
  TradeGeneralInfoUpdated = 'TRADE_GENERAL_INFO_UPDATED',
  TradeInitiated = 'TRADE_INITIATED',
  TradeNoteAdded = 'TRADE_NOTE_ADDED',
  TradeNoteEdited = 'TRADE_NOTE_EDITED',
  TradeViewed = 'TRADE_VIEWED',
  UserActivated = 'USER_ACTIVATED',
  UserAuthenticated = 'USER_AUTHENTICATED',
  UserChatAliasUpdated = 'USER_CHAT_ALIAS_UPDATED',
  UserCreated = 'USER_CREATED',
  UserDeactivated = 'USER_DEACTIVATED',
  UserDeleted = 'USER_DELETED',
  UserLogin = 'USER_LOGIN',
  UserPermissionUpdated = 'USER_PERMISSION_UPDATED',
  UserRoleAdded = 'USER_ROLE_ADDED',
  UserRoleRemoved = 'USER_ROLE_REMOVED',
  UserUpdated = 'USER_UPDATED',
  WorkingDraftCreated = 'WORKING_DRAFT_CREATED',
  WorkingDraftDeleted = 'WORKING_DRAFT_DELETED',
  WorkingDraftUpdated = 'WORKING_DRAFT_UPDATED'
}

export type ActivityPageInfo = {
  __typename?: 'ActivityPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ActivityRelayResponse = {
  __typename?: 'ActivityRelayResponse';
  page: ActivityConnection;
  pageData?: Maybe<PageData>;
};

export type AuctionBid = {
  __typename?: 'AuctionBid';
  auctionBidSummaryByTradeCompany?: Maybe<Array<AuctionBidSummary>>;
  topBid?: Maybe<Bid>;
  totalBids?: Maybe<Scalars['Int']>;
};

export type AuctionBidSummary = {
  __typename?: 'AuctionBidSummary';
  topBid?: Maybe<Bid>;
  totalBids?: Maybe<Scalars['Int']>;
};

export type Bid = {
  __typename?: 'Bid';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activity: Activity;
  /** Returns the available actions that can be performed on this bid. */
  availableActions?: Maybe<Scalars['JSON']>;
  base: Scalars['Boolean'];
  bidType: BidType;
  bidValue?: Maybe<BidValue>;
  createdAt?: Maybe<Scalars['DateTime']>;
  draft: Scalars['Boolean'];
  /** Returns the time at which the bid will expire. */
  expiryTime?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  read: Scalars['Boolean'];
  status: BidStatus;
  submittedAt?: Maybe<Scalars['DateTime']>;
  submitter?: Maybe<Company>;
  termsheet?: Maybe<Termsheet>;
  trade: Trade;
  tradeCompany?: Maybe<TradeCompany>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The time that the bid remains valid after progression to consideration in tenders (or immediately after submission in bilaterals), in seconds. */
  validityPeriod?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Float']>;
  withdrawnAt?: Maybe<Scalars['DateTime']>;
};

export type BidConnection = {
  __typename?: 'BidConnection';
  edges?: Maybe<Array<BidEdge>>;
  pageInfo?: Maybe<BidPageInfo>;
};

export type BidEdge = {
  __typename?: 'BidEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Bid>;
};

export type BidInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']>;
  activity?: InputMaybe<ActivityInput>;
  base?: InputMaybe<Scalars['Boolean']>;
  bidType?: InputMaybe<BidType>;
  bidValue?: InputMaybe<BidValueInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  read?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BidStatus>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  submitter?: InputMaybe<CompanyInput>;
  termsheet?: InputMaybe<TermsheetInput>;
  trade?: InputMaybe<TradeInput>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The time that the bid remains valid after progression to consideration in tenders (or immediately after submission in bilaterals), in seconds. */
  validityPeriod?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Float']>;
  withdrawnAt?: InputMaybe<Scalars['DateTime']>;
};

export type BidListResponse = {
  __typename?: 'BidListResponse';
  data: Array<Bid>;
  pageData?: Maybe<PageData>;
};

export type BidPageInfo = {
  __typename?: 'BidPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type BidRelayResponse = {
  __typename?: 'BidRelayResponse';
  page: BidConnection;
  pageData?: Maybe<PageData>;
};

export enum BidStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Submitted = 'SUBMITTED',
  Withdrawn = 'WITHDRAWN'
}

export type BidSubscriptionEvent = {
  __typename?: 'BidSubscriptionEvent';
  action: Scalars['String'];
  bid: Bid;
};

export enum BidType {
  Bid = 'BID',
  Offer = 'OFFER'
}

export type BidValue = {
  __typename?: 'BidValue';
  bid: Bid;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: TradeCurrency;
  id: Scalars['Int'];
  unit: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type BidValueInput = {
  bid?: InputMaybe<BidInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency?: InputMaybe<TradeCurrency>;
  id?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  broadcast: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  tradeCompany: TradeCompany;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type ChatMessageBroadcast = {
  __typename?: 'ChatMessageBroadcast';
  chatIdMap: Scalars['JSON'];
  chatMessage: ChatMessage;
};

export type ChatMessageBroadcastInput = {
  broadcast?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  tradeCompany?: InputMaybe<Array<TradeCompanyInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  edges?: Maybe<Array<ChatMessageEdge>>;
  pageInfo?: Maybe<ChatMessagePageInfo>;
};

export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ChatMessage>;
};

export type ChatMessageInput = {
  broadcast?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type ChatMessageListResponse = {
  __typename?: 'ChatMessageListResponse';
  data: Array<ChatMessage>;
  pageData?: Maybe<PageData>;
};

export type ChatMessagePageInfo = {
  __typename?: 'ChatMessagePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ChatMessageRegister = {
  __typename?: 'ChatMessageRegister';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastReadMessage: ChatMessage;
  tradeCompany: TradeCompany;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type ChatMessageRegisterConnection = {
  __typename?: 'ChatMessageRegisterConnection';
  edges?: Maybe<Array<ChatMessageRegisterEdge>>;
  pageInfo?: Maybe<ChatMessageRegisterPageInfo>;
};

export type ChatMessageRegisterEdge = {
  __typename?: 'ChatMessageRegisterEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ChatMessageRegister>;
};

export type ChatMessageRegisterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  lastReadMessage?: InputMaybe<ChatMessageInput>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type ChatMessageRegisterListResponse = {
  __typename?: 'ChatMessageRegisterListResponse';
  data: Array<ChatMessageRegister>;
  pageData?: Maybe<PageData>;
};

export type ChatMessageRegisterPageInfo = {
  __typename?: 'ChatMessageRegisterPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ChatMessageRegisterRelayResponse = {
  __typename?: 'ChatMessageRegisterRelayResponse';
  page: ChatMessageRegisterConnection;
  pageData?: Maybe<PageData>;
};

export type ChatMessageRelayResponse = {
  __typename?: 'ChatMessageRelayResponse';
  page: ChatMessageConnection;
  pageData?: Maybe<PageData>;
};

export type ChatThread = {
  __typename?: 'ChatThread';
  activities?: Maybe<Array<Activity>>;
  awarded: Scalars['Boolean'];
  /** Returns the base term sheet for a company */
  baseCounterpartyTermsheet?: Maybe<Termsheet>;
  baseTermsheets?: Maybe<Array<Termsheet>>;
  bids?: Maybe<Array<Bid>>;
  chatMessages?: Maybe<Array<ChatMessage>>;
  company: Company;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  latestChatMessage?: Maybe<ChatMessage>;
  ref?: Maybe<Scalars['String']>;
  trade: Trade;
  tradeCompanyUsers?: Maybe<Array<TradeCompanyUser>>;
  unreadChatMessageCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type ChatThreadListResponse = {
  __typename?: 'ChatThreadListResponse';
  data: Array<ChatThread>;
  pageData?: Maybe<PageData>;
};

export type Company = {
  __typename?: 'Company';
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  bids?: Maybe<Array<Bid>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Boolean']>;
  postalCode?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tradeCompanies?: Maybe<Array<TradeCompany>>;
  tradeNotes?: Maybe<Array<TradeNote>>;
  trades?: Maybe<Array<Trade>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<User>>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges?: Maybe<Array<CompanyEdge>>;
  pageInfo?: Maybe<CompanyPageInfo>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Company>;
};

export type CompanyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  ref?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CompanyListResponse = {
  __typename?: 'CompanyListResponse';
  data: Array<Company>;
  pageData?: Maybe<PageData>;
};

export type CompanyPageInfo = {
  __typename?: 'CompanyPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CompanyRelayResponse = {
  __typename?: 'CompanyRelayResponse';
  page: CompanyConnection;
  pageData?: Maybe<PageData>;
};

export type ConfigInput = {
  config?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  documentKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  submitter: User;
  trade?: Maybe<Trade>;
  type: DocumentType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges?: Maybe<Array<DocumentEdge>>;
  pageInfo?: Maybe<DocumentPageInfo>;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Document>;
};

export type DocumentInput = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  documentKey?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  submitter?: InputMaybe<UserInput>;
  trade?: InputMaybe<TradeInput>;
  type?: InputMaybe<DocumentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentListResponse = {
  __typename?: 'DocumentListResponse';
  data: Array<Document>;
  pageData?: Maybe<PageData>;
};

export type DocumentPageInfo = {
  __typename?: 'DocumentPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type DocumentRelayResponse = {
  __typename?: 'DocumentRelayResponse';
  page: DocumentConnection;
  pageData?: Maybe<PageData>;
};

export enum DocumentType {
  Contract = 'CONTRACT',
  Credit = 'CREDIT',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  Shipping = 'SHIPPING'
}

export type DocumentUploadUrl = {
  __typename?: 'DocumentUploadUrl';
  key: Scalars['String'];
  url: Scalars['String'];
};

export type Metrics = {
  __typename?: 'Metrics';
  awardedTerms: Scalars['Float'];
  awardedTrades: Scalars['Float'];
  chartData: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  initiatedTrades: Scalars['Float'];
  transferredBids: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptBid: Bid;
  addTradeCompanies: Trade;
  /** Forces a password change for the given user. */
  changePassword: Scalars['Boolean'];
  closeTrade: Trade;
  configureGroups: Scalars['JSON'];
  configureOIDC: Scalars['JSON'];
  configureSAML: Scalars['JSON'];
  copyTradeDocuments: Array<Document>;
  deleteDocument: Document;
  deleteDraft: Bid;
  deleteTrade: Scalars['Boolean'];
  disableCompany: Scalars['Boolean'];
  disableOTP: Scalars['Boolean'];
  disableSSO: Scalars['JSON'];
  disableUser: Scalars['Boolean'];
  enableCompany: Scalars['Boolean'];
  enableOTP: Scalars['Boolean'];
  enableUser: Scalars['Boolean'];
  extendTrade: Trade;
  /** Invites a list of users by email, returning the emails of those users successfully invited. */
  inviteUsers: Array<Scalars['String']>;
  markAllRead: Array<Notification>;
  markAllSeen: Array<Notification>;
  markRead: Array<Notification>;
  markSeen: Array<Notification>;
  removeChatMessageRegister: ChatMessageRegister;
  reviewTermsheetReview: TermsheetReview;
  saveBid: Bid;
  saveChatMessage: ChatMessage;
  saveChatMessageBroadcast: ChatMessage;
  saveChatMessageRegister: ChatMessageRegister;
  saveCompany: Company;
  saveConfig: Scalars['JSON'];
  saveDocument: Document;
  saveNotificationSettings: User;
  savePartialTrade: Trade;
  savePartialTradeCompanies: Trade;
  saveRole: Scalars['JSON'];
  saveTermsheet: Termsheet;
  saveTermsheetReview: TermsheetReview;
  saveTermsheetReviewChat: TermsheetReviewChat;
  saveTradeNote: TradeNote;
  saveUserRoles: User;
  sendBid: Bid;
  sendDraft: Bid;
  setForceSSO: Scalars['JSON'];
  submitAuctionBid: Bid;
  submitPartialTrade: Trade;
  tradeView: Scalars['Int'];
  updateChatMessageRegister: ChatMessageRegister;
  updateProfile: User;
  updateTradeInfo: Trade;
  updateTradeRef: Trade;
  uploadAndScanFile: DocumentUploadUrl;
  validateTrade: Scalars['JSON'];
  watchTermsheetReview: TermsheetReview;
  watchTrade: Trade;
  withdrawBid: Bid;
};


export type MutationAcceptBidArgs = {
  id: Scalars['Float'];
};


export type MutationAddTradeCompaniesArgs = {
  isLastChunk?: InputMaybe<Scalars['Boolean']>;
  tradeCompanies: Array<TradeCompanyInput>;
  tradeId: Scalars['Int'];
};


export type MutationChangePasswordArgs = {
  username: Scalars['String'];
};


export type MutationCloseTradeArgs = {
  tradeId: Scalars['Int'];
};


export type MutationConfigureGroupsArgs = {
  claimName: Scalars['String'];
  roleMappings?: InputMaybe<Array<RoleMapping>>;
  ssoType: SsoType;
};


export type MutationConfigureOidcArgs = {
  authLabel?: InputMaybe<Scalars['String']>;
  authorizationUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  issuer: Scalars['String'];
  jwksUrl: Scalars['String'];
  tokenUrl: Scalars['String'];
};


export type MutationConfigureSamlArgs = {
  authLabel?: InputMaybe<Scalars['String']>;
  certificate: Scalars['String'];
  firstNameClaim?: InputMaybe<Scalars['String']>;
  lastNameClaim?: InputMaybe<Scalars['String']>;
  loginUrl: Scalars['String'];
  principalAttribute?: InputMaybe<Scalars['String']>;
};


export type MutationCopyTradeDocumentsArgs = {
  tradeId?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteDocumentArgs = {
  documentId?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteDraftArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteTradeArgs = {
  tradeId?: InputMaybe<Scalars['Int']>;
};


export type MutationDisableCompanyArgs = {
  companyId: Scalars['Int'];
};


export type MutationDisableOtpArgs = {
  username: Scalars['String'];
};


export type MutationDisableUserArgs = {
  userId: Scalars['Int'];
};


export type MutationEnableCompanyArgs = {
  companyId: Scalars['Int'];
};


export type MutationEnableOtpArgs = {
  username: Scalars['String'];
};


export type MutationEnableUserArgs = {
  userId: Scalars['Int'];
};


export type MutationExtendTradeArgs = {
  endDate: Scalars['DateTime'];
  tradeId: Scalars['Int'];
};


export type MutationInviteUsersArgs = {
  companyId: Scalars['Int'];
  users: Array<UserInput>;
};


export type MutationMarkReadArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationMarkSeenArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationRemoveChatMessageRegisterArgs = {
  id: Scalars['Int'];
};


export type MutationReviewTermsheetReviewArgs = {
  termsheetReviewId: Scalars['Int'];
  termsheetReviewStatus: TermsheetReviewStatus;
};


export type MutationSaveBidArgs = {
  bid: BidInput;
  parent: BidInput;
  tradeId: Scalars['Float'];
};


export type MutationSaveChatMessageArgs = {
  chatMessage: ChatMessageInput;
};


export type MutationSaveChatMessageBroadcastArgs = {
  chatMessageBroadcast: ChatMessageBroadcastInput;
};


export type MutationSaveChatMessageRegisterArgs = {
  chatMessageRegister: ChatMessageRegisterInput;
};


export type MutationSaveCompanyArgs = {
  company: CompanyInput;
};


export type MutationSaveConfigArgs = {
  config: ConfigInput;
};


export type MutationSaveDocumentArgs = {
  document: DocumentInput;
};


export type MutationSaveNotificationSettingsArgs = {
  user: UserInput;
};


export type MutationSavePartialTradeArgs = {
  step?: InputMaybe<Scalars['Int']>;
  trade: TradeInput;
};


export type MutationSavePartialTradeCompaniesArgs = {
  tradeCompanies: Array<TradeCompanyInput>;
  tradeId: Scalars['Int'];
};


export type MutationSaveRoleArgs = {
  role: Role;
};


export type MutationSaveTermsheetArgs = {
  termsheet: TermsheetInput;
};


export type MutationSaveTermsheetReviewArgs = {
  termsheetId: Scalars['Float'];
  termsheetReview: TermsheetReviewInput;
};


export type MutationSaveTermsheetReviewChatArgs = {
  termsheetReviewChat: TermsheetReviewChatInput;
};


export type MutationSaveTradeNoteArgs = {
  tradeNote: TradeNoteInput;
};


export type MutationSaveUserRolesArgs = {
  roles: Array<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationSendBidArgs = {
  id: Scalars['Float'];
  validityPeriod?: InputMaybe<Scalars['Float']>;
};


export type MutationSendDraftArgs = {
  id: Scalars['Float'];
};


export type MutationSetForceSsoArgs = {
  forceSSO: Scalars['Boolean'];
  ssoType: SsoType;
};


export type MutationSubmitAuctionBidArgs = {
  tradeId: Scalars['Float'];
  value: Scalars['Float'];
};


export type MutationSubmitPartialTradeArgs = {
  tradeId: Scalars['Int'];
};


export type MutationTradeViewArgs = {
  tradeId: Scalars['Int'];
};


export type MutationUpdateChatMessageRegisterArgs = {
  messageId: Scalars['Int'];
  tradeCompanyId: Scalars['Int'];
};


export type MutationUpdateProfileArgs = {
  user: UserInput;
};


export type MutationUpdateTradeInfoArgs = {
  info: Scalars['String'];
  tradeId: Scalars['Int'];
};


export type MutationUpdateTradeRefArgs = {
  ref: Scalars['String'];
  tradeId: Scalars['Int'];
};


export type MutationUploadAndScanFileArgs = {
  contentType: Scalars['String'];
  file: Scalars['Upload'];
  fileName: Scalars['String'];
};


export type MutationValidateTradeArgs = {
  step?: InputMaybe<Scalars['Int']>;
  trade: TradeInput;
};


export type MutationWatchTermsheetReviewArgs = {
  termsheetReviewId: Scalars['Int'];
  watch: Scalars['Boolean'];
};


export type MutationWatchTradeArgs = {
  tradeId: Scalars['Int'];
  watch: Scalars['Boolean'];
};


export type MutationWithdrawBidArgs = {
  id: Scalars['Float'];
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['JSON'];
  id: Scalars['Int'];
  read: Scalars['Boolean'];
  seen: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges?: Maybe<Array<NotificationEdge>>;
  pageInfo?: Maybe<NotificationPageInfo>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Notification>;
};

export type NotificationInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  read?: InputMaybe<Scalars['Boolean']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type NotificationListResponse = {
  __typename?: 'NotificationListResponse';
  data: Array<Notification>;
  pageData?: Maybe<PageData>;
};

export type NotificationPageInfo = {
  __typename?: 'NotificationPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type NotificationRelayResponse = {
  __typename?: 'NotificationRelayResponse';
  page: NotificationConnection;
  pageData?: Maybe<PageData>;
};

export type PageData = {
  __typename?: 'PageData';
  count: Scalars['Float'];
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  activities: ActivityListResponse;
  activitiesCursor: ActivityRelayResponse;
  activity: Activity;
  activityLog: ActivityLog;
  activityLogs: ActivityLogListResponse;
  activityLogsCursor: ActivityLogRelayResponse;
  bid: Bid;
  bids: BidListResponse;
  bidsCursor: BidRelayResponse;
  chatMessage: ChatMessage;
  chatMessageRegister: ChatMessageRegister;
  chatMessageRegisters: ChatMessageRegisterListResponse;
  chatMessageRegistersCursor: ChatMessageRegisterRelayResponse;
  chatMessages: ChatMessageListResponse;
  chatMessagesCursor: ChatMessageRelayResponse;
  companies: CompanyListResponse;
  companiesCursor: CompanyRelayResponse;
  company: Company;
  document: Document;
  documents: DocumentListResponse;
  documentsCursor: DocumentRelayResponse;
  exportChatMessages: Scalars['String'];
  exportTermsheets: Scalars['String'];
  fetchConfig: Scalars['JSON'];
  getDirectoryUser: Scalars['JSON'];
  getInformation: Scalars['JSON'];
  getThreads: ChatThreadListResponse;
  getUsersForNotes: Array<User>;
  getUsersWithTermsheetReviewPermissions: Array<User>;
  metrics: Metrics;
  notification: Notification;
  notificationTypes: Scalars['JSON'];
  notifications: NotificationListResponse;
  notificationsCursor: NotificationRelayResponse;
  preSignedUrlForUpload: DocumentUploadUrl;
  preSignedUrlToView: Scalars['String'];
  ready: Scalars['Boolean'];
  role: Scalars['JSON'];
  roles: Scalars['JSON'];
  termsheet: Termsheet;
  termsheetReview: TermsheetReview;
  termsheetReviewChat: TermsheetReviewChat;
  termsheetReviewChats: TermsheetReviewChatListResponse;
  termsheetReviewChatsCursor: TermsheetReviewChatRelayResponse;
  termsheetReviewMetrics: TermSheetReviewMetrics;
  termsheetReviews: TermsheetReviewListResponse;
  termsheetReviewsCursor: TermsheetReviewRelayResponse;
  termsheets: TermsheetListResponse;
  termsheetsCursor: TermsheetRelayResponse;
  timeSync: Scalars['JSON'];
  /** Returns the top bids for an auction. */
  topAuctionBids?: Maybe<AuctionBid>;
  trade: Trade;
  tradeCompanies: TradeCompanyListResponse;
  tradeCompaniesCursor: TradeCompanyRelayResponse;
  tradeCompany: TradeCompany;
  tradeMeta: TradeMeta;
  tradeNote: TradeNote;
  tradeNotes: TradeNoteListResponse;
  tradeNotesCursor: TradeNoteRelayResponse;
  trades: TradeListResponse;
  tradesCursor: TradeRelayResponse;
  unseenCount: Scalars['Int'];
  user: User;
  users: UserListResponse;
  usersCursor: UserRelayResponse;
  usersWithRoles: UserListResponse;
};


export type QueryActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryActivitiesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryActivityArgs = {
  query: Scalars['JSON'];
};


export type QueryActivityLogArgs = {
  query: Scalars['JSON'];
};


export type QueryActivityLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryActivityLogsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryBidArgs = {
  query: Scalars['JSON'];
};


export type QueryBidsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryBidsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryChatMessageArgs = {
  query: Scalars['JSON'];
};


export type QueryChatMessageRegisterArgs = {
  query: Scalars['JSON'];
};


export type QueryChatMessageRegistersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryChatMessageRegistersCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryChatMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryChatMessagesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompaniesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryCompanyArgs = {
  query: Scalars['JSON'];
};


export type QueryDocumentArgs = {
  query: Scalars['JSON'];
};


export type QueryDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryDocumentsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryExportChatMessagesArgs = {
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
};


export type QueryExportTermsheetsArgs = {
  termsheetIds: Array<Scalars['Int']>;
};


export type QueryGetDirectoryUserArgs = {
  username: Scalars['String'];
};


export type QueryGetThreadsArgs = {
  tradeUid: Scalars['String'];
};


export type QueryMetricsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryNotificationArgs = {
  query: Scalars['JSON'];
};


export type QueryNotificationTypesArgs = {
  id: Scalars['Int'];
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryNotificationsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryPreSignedUrlForUploadArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};


export type QueryPreSignedUrlToViewArgs = {
  key: Scalars['String'];
};


export type QueryRoleArgs = {
  roleId: Scalars['String'];
};


export type QueryRolesArgs = {
  includeSubRoles: Scalars['Boolean'];
  roleType?: InputMaybe<RoleType>;
};


export type QueryTermsheetArgs = {
  query: Scalars['JSON'];
};


export type QueryTermsheetReviewArgs = {
  query: Scalars['JSON'];
};


export type QueryTermsheetReviewChatArgs = {
  query: Scalars['JSON'];
};


export type QueryTermsheetReviewChatsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetReviewChatsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetReviewMetricsArgs = {
  query?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetReviewsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTermsheetsCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTimeSyncArgs = {
  data: Scalars['JSON'];
};


export type QueryTopAuctionBidsArgs = {
  tradeId: Scalars['Int'];
};


export type QueryTradeArgs = {
  query: Scalars['JSON'];
};


export type QueryTradeCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTradeCompaniesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTradeCompanyArgs = {
  query: Scalars['JSON'];
};


export type QueryTradeMetaArgs = {
  tradeId: Scalars['Int'];
};


export type QueryTradeNoteArgs = {
  query: Scalars['JSON'];
};


export type QueryTradeNotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTradeNotesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTradesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryTradesCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  query: Scalars['JSON'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryUsersCursorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['JSON']>;
  sort?: InputMaybe<Scalars['JSON']>;
};


export type QueryUsersWithRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
};

export enum ReviewSystemMessageType {
  Declined = 'DECLINED',
  Reverted = 'REVERTED',
  Supported = 'SUPPORTED'
}

export type Role = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['String']>>;
};

export type RoleMapping = {
  claimValue: Scalars['String'];
  roleName: Scalars['String'];
};

export enum RoleType {
  Composite = 'COMPOSITE',
  Single = 'SINGLE'
}

export enum SsoType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type Subscription = {
  __typename?: 'Subscription';
  auctionBidSubscriptionEvent: BidSubscriptionEvent;
  bidSubscriptionEvent: BidSubscriptionEvent;
  chatMessage: ChatMessage;
  chatMessageBroadcast: ChatMessageBroadcast;
  document: Document;
  newTrade: Trade;
  newUser: User;
  notification: Notification;
  termsheetReview: TermsheetReview;
  termsheetReviewChat: TermsheetReviewChat;
  tradeCompanyAdded: TradeCompany;
  tradeDetails: Trade;
  tradeNote: TradeNote;
};


export type SubscriptionAuctionBidSubscriptionEventArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionBidSubscriptionEventArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionChatMessageArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionChatMessageBroadcastArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionDocumentArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionTermsheetReviewArgs = {
  termsheetReviewId: Scalars['Int'];
};


export type SubscriptionTermsheetReviewChatArgs = {
  termsheetReviewId: Scalars['Int'];
};


export type SubscriptionTradeCompanyAddedArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionTradeDetailsArgs = {
  tradeId: Scalars['Int'];
};


export type SubscriptionTradeNoteArgs = {
  tradeId: Scalars['Int'];
};

export type TermSheetReviewMetrics = {
  __typename?: 'TermSheetReviewMetrics';
  declinedReviews: Scalars['Float'];
  pendingReviews: Scalars['Float'];
  supportedReviews: Scalars['Float'];
};

export type Termsheet = {
  __typename?: 'Termsheet';
  bid?: Maybe<Bid>;
  children: Array<Termsheet>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  parent?: Maybe<Termsheet>;
  /** Converts a terms array from GQL to json and back. */
  terms: Scalars['JSON'];
  termsheetType: TermsheetType;
  trade?: Maybe<Trade>;
  tradeCompany?: Maybe<TradeCompany>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Float']>;
};

export type TermsheetConnection = {
  __typename?: 'TermsheetConnection';
  edges?: Maybe<Array<TermsheetEdge>>;
  pageInfo?: Maybe<TermsheetPageInfo>;
};

export type TermsheetEdge = {
  __typename?: 'TermsheetEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Termsheet>;
};

export type TermsheetInput = {
  children?: InputMaybe<TermsheetInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<TermsheetInput>;
  /** Converts a terms array from GQL to json and back. */
  terms?: InputMaybe<Scalars['JSON']>;
  termsheetType?: InputMaybe<TermsheetType>;
  trade?: InputMaybe<TradeInput>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  version?: InputMaybe<Scalars['Float']>;
};

export type TermsheetListResponse = {
  __typename?: 'TermsheetListResponse';
  data: Array<Termsheet>;
  pageData?: Maybe<PageData>;
};

export type TermsheetPageInfo = {
  __typename?: 'TermsheetPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TermsheetRelayResponse = {
  __typename?: 'TermsheetRelayResponse';
  page: TermsheetConnection;
  pageData?: Maybe<PageData>;
};

export type TermsheetReview = {
  __typename?: 'TermsheetReview';
  allowCompare?: Maybe<Scalars['Boolean']>;
  /** The matching base terms for the selected list of terms. This will be null if allowCompare is false. */
  baseTerms?: Maybe<Scalars['JSON']>;
  bidSnapshot?: Maybe<Scalars['JSON']>;
  comment: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  hideCpName?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  requestor: User;
  reviewType: Scalars['String'];
  /** The list of terms that have been selected for review. This may be a subset of the terms from the linked term sheet. */
  terms: Scalars['JSON'];
  termsheetId: Scalars['Int'];
  termsheetReviewChats?: Maybe<Array<TermsheetReviewChat>>;
  termsheetReviewStatus: TermsheetReviewStatus;
  termsheetReviewUsers?: Maybe<Array<TermsheetReviewUser>>;
  termsheetVersion: Scalars['Int'];
  trade?: Maybe<Trade>;
  tradeMeta?: Maybe<TradeMeta>;
  tradeSnapshot?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  watch?: Maybe<Scalars['Boolean']>;
};

export type TermsheetReviewChat = {
  __typename?: 'TermsheetReviewChat';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  systemType?: Maybe<ReviewSystemMessageType>;
  termsheetReview: TermsheetReview;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type TermsheetReviewChatConnection = {
  __typename?: 'TermsheetReviewChatConnection';
  edges?: Maybe<Array<TermsheetReviewChatEdge>>;
  pageInfo?: Maybe<TermsheetReviewChatPageInfo>;
};

export type TermsheetReviewChatEdge = {
  __typename?: 'TermsheetReviewChatEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TermsheetReviewChat>;
};

export type TermsheetReviewChatInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  termsheetReview?: InputMaybe<TermsheetReviewInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type TermsheetReviewChatListResponse = {
  __typename?: 'TermsheetReviewChatListResponse';
  data: Array<TermsheetReviewChat>;
  pageData?: Maybe<PageData>;
};

export type TermsheetReviewChatPageInfo = {
  __typename?: 'TermsheetReviewChatPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TermsheetReviewChatRelayResponse = {
  __typename?: 'TermsheetReviewChatRelayResponse';
  page: TermsheetReviewChatConnection;
  pageData?: Maybe<PageData>;
};

export type TermsheetReviewConnection = {
  __typename?: 'TermsheetReviewConnection';
  edges?: Maybe<Array<TermsheetReviewEdge>>;
  pageInfo?: Maybe<TermsheetReviewPageInfo>;
};

export type TermsheetReviewEdge = {
  __typename?: 'TermsheetReviewEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TermsheetReview>;
};

export type TermsheetReviewInput = {
  allowCompare?: InputMaybe<Scalars['Boolean']>;
  bidSnapshot?: InputMaybe<Scalars['JSON']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hideCpName?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  requestor?: InputMaybe<UserInput>;
  reviewType?: InputMaybe<Scalars['String']>;
  /** The list of terms that have been selected for review. This may be a subset of the terms from the linked term sheet. */
  terms?: InputMaybe<Scalars['JSON']>;
  termsheetId?: InputMaybe<Scalars['Int']>;
  termsheetReviewChats?: InputMaybe<Array<TermsheetReviewChatInput>>;
  termsheetReviewStatus?: InputMaybe<TermsheetReviewStatus>;
  termsheetReviewUsers?: InputMaybe<Array<TermsheetReviewUserInput>>;
  termsheetVersion?: InputMaybe<Scalars['Int']>;
  trade?: InputMaybe<TradeInput>;
  tradeSnapshot?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TermsheetReviewListResponse = {
  __typename?: 'TermsheetReviewListResponse';
  data: Array<TermsheetReview>;
  pageData?: Maybe<PageData>;
};

export type TermsheetReviewPageInfo = {
  __typename?: 'TermsheetReviewPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TermsheetReviewRelayResponse = {
  __typename?: 'TermsheetReviewRelayResponse';
  page: TermsheetReviewConnection;
  pageData?: Maybe<PageData>;
};

export enum TermsheetReviewStatus {
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Supported = 'SUPPORTED'
}

export type TermsheetReviewUser = {
  __typename?: 'TermsheetReviewUser';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type TermsheetReviewUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  termsheetReview?: InputMaybe<TermsheetReviewInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export enum TermsheetType {
  Base = 'BASE',
  BaseCounterparty = 'BASE_COUNTERPARTY',
  Template = 'TEMPLATE',
  Trade = 'TRADE'
}

export type Trade = {
  __typename?: 'Trade';
  awardedCount?: Maybe<Scalars['Float']>;
  baseTermsheet?: Maybe<Termsheet>;
  bids?: Maybe<Array<Bid>>;
  considerationPeriod?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<TradeCurrency>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['Int'];
  information?: Maybe<Scalars['String']>;
  initiator: Company;
  priceUnit?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  reservePrice?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
  tradeCompanies?: Maybe<Array<TradeCompany>>;
  tradeConsiderationEnd?: Maybe<Scalars['DateTime']>;
  tradeEnd?: Maybe<Scalars['DateTime']>;
  tradeNotes?: Maybe<Array<TradeNote>>;
  tradeStart?: Maybe<Scalars['DateTime']>;
  tradeStatus: TradeStatus;
  tradeType: TradeType;
  /** The validity period for bids/offers in this trade, in seconds. The effect of this field is dependent on tradeValidityType. */
  tradeValidityPeriod?: Maybe<Scalars['Int']>;
  /** The validity style for bids/offers in this trade, if the trade is a tender. `NONE` will assume all parties can set a bid/offer validity without restriction. `DEFAULT` will set a default bid validity, but allow overrides by the submitting party. `FIXED` sets a fixed validity, with only the owning company able to override the validity on their bids/offers. */
  tradeValidityType?: Maybe<TradeValidityType>;
  trader: User;
  transactionType: TransactionType;
  uid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  watch?: Maybe<Scalars['Boolean']>;
};

export enum TradeActivityType {
  BaseTerm = 'BASE_TERM',
  Bid = 'BID',
  Counteroffer = 'COUNTEROFFER',
  Other = 'OTHER',
  Termsheet = 'TERMSHEET'
}

export type TradeCompany = {
  __typename?: 'TradeCompany';
  activities?: Maybe<Array<Activity>>;
  awarded: Scalars['Boolean'];
  /** Returns the base term sheet for a company */
  baseCounterpartyTermsheet?: Maybe<Termsheet>;
  baseTermsheets?: Maybe<Array<Termsheet>>;
  bids?: Maybe<Array<Bid>>;
  chatMessages?: Maybe<Array<ChatMessage>>;
  company: Company;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  ref?: Maybe<Scalars['String']>;
  trade: Trade;
  tradeCompanyUsers?: Maybe<Array<TradeCompanyUser>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type TradeCompanyConnection = {
  __typename?: 'TradeCompanyConnection';
  edges?: Maybe<Array<TradeCompanyEdge>>;
  pageInfo?: Maybe<TradeCompanyPageInfo>;
};

export type TradeCompanyEdge = {
  __typename?: 'TradeCompanyEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TradeCompany>;
};

export type TradeCompanyInput = {
  activities?: InputMaybe<Array<ActivityInput>>;
  awarded?: InputMaybe<Scalars['Boolean']>;
  baseTermsheets?: InputMaybe<Array<TermsheetInput>>;
  chatMessages?: InputMaybe<Array<ChatMessageInput>>;
  company?: InputMaybe<CompanyInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<TradeInput>;
  tradeCompanyUsers?: InputMaybe<Array<TradeCompanyUserInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  viewCount?: InputMaybe<Scalars['Int']>;
};

export type TradeCompanyListResponse = {
  __typename?: 'TradeCompanyListResponse';
  data: Array<TradeCompany>;
  pageData?: Maybe<PageData>;
};

export type TradeCompanyPageInfo = {
  __typename?: 'TradeCompanyPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TradeCompanyRelayResponse = {
  __typename?: 'TradeCompanyRelayResponse';
  page: TradeCompanyConnection;
  pageData?: Maybe<PageData>;
};

export type TradeCompanyUser = {
  __typename?: 'TradeCompanyUser';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: User;
};

export type TradeCompanyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  tradeCompany?: InputMaybe<TradeCompanyInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
};

export type TradeConnection = {
  __typename?: 'TradeConnection';
  edges?: Maybe<Array<TradeEdge>>;
  pageInfo?: Maybe<TradePageInfo>;
};

export enum TradeCurrency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type TradeEdge = {
  __typename?: 'TradeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Trade>;
};

export type TradeInput = {
  awardedCount?: InputMaybe<Scalars['Float']>;
  baseTermsheet?: InputMaybe<TermsheetInput>;
  considerationPeriod?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency?: InputMaybe<TradeCurrency>;
  documents?: InputMaybe<Array<DocumentInput>>;
  id?: InputMaybe<Scalars['Int']>;
  information?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<CompanyInput>;
  priceUnit?: InputMaybe<Scalars['String']>;
  ref?: InputMaybe<Scalars['String']>;
  reservePrice?: InputMaybe<Scalars['String']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
  tradeCompanies?: InputMaybe<Array<TradeCompanyInput>>;
  tradeConsiderationEnd?: InputMaybe<Scalars['DateTime']>;
  tradeEnd?: InputMaybe<Scalars['DateTime']>;
  tradeStart?: InputMaybe<Scalars['DateTime']>;
  tradeStatus?: InputMaybe<TradeStatus>;
  tradeType?: InputMaybe<TradeType>;
  /** The validity period for bids/offers in this trade, in seconds. The effect of this field is dependent on tradeValidityType. */
  tradeValidityPeriod?: InputMaybe<Scalars['Int']>;
  /** The validity style for bids/offers in this trade, if the trade is a tender. `NONE` will assume all parties can set a bid/offer validity without restriction. `DEFAULT` will set a default bid validity, but allow overrides by the submitting party. `FIXED` sets a fixed validity, with only the owning company able to override the validity on their bids/offers. */
  tradeValidityType?: InputMaybe<TradeValidityType>;
  trader?: InputMaybe<UserInput>;
  transactionType?: InputMaybe<TransactionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  watchingUsers?: InputMaybe<Array<UserInput>>;
};

export type TradeListResponse = {
  __typename?: 'TradeListResponse';
  data: Array<Trade>;
  pageData?: Maybe<PageData>;
};

export type TradeMeta = {
  __typename?: 'TradeMeta';
  currency?: Maybe<TradeCurrency>;
  id: Scalars['Int'];
  priceUnit?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  tradeStatus: TradeStatus;
  tradeType: TradeType;
  transactionType: TransactionType;
  uid: Scalars['String'];
};

export type TradeNote = {
  __typename?: 'TradeNote';
  company: Company;
  createdAt?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['JSON']>;
  submitter: User;
  trade: Trade;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TradeNoteConnection = {
  __typename?: 'TradeNoteConnection';
  edges?: Maybe<Array<TradeNoteEdge>>;
  pageInfo?: Maybe<TradeNotePageInfo>;
};

export type TradeNoteEdge = {
  __typename?: 'TradeNoteEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TradeNote>;
};

export type TradeNoteInput = {
  company?: InputMaybe<CompanyInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['JSON']>;
  submitter?: InputMaybe<UserInput>;
  trade?: InputMaybe<TradeInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TradeNoteListResponse = {
  __typename?: 'TradeNoteListResponse';
  data: Array<TradeNote>;
  pageData?: Maybe<PageData>;
};

export type TradeNotePageInfo = {
  __typename?: 'TradeNotePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TradeNoteRelayResponse = {
  __typename?: 'TradeNoteRelayResponse';
  page: TradeNoteConnection;
  pageData?: Maybe<PageData>;
};

export type TradePageInfo = {
  __typename?: 'TradePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type TradeRelayResponse = {
  __typename?: 'TradeRelayResponse';
  page: TradeConnection;
  pageData?: Maybe<PageData>;
};

export enum TradeStatus {
  Closed = 'CLOSED',
  Consideration = 'CONSIDERATION',
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export enum TradeType {
  Auction = 'AUCTION',
  Bilateral = 'BILATERAL',
  DealConfirmation = 'DEAL_CONFIRMATION',
  Tender = 'TENDER'
}

export enum TradeValidityType {
  Default = 'DEFAULT',
  Fixed = 'FIXED',
  None = 'NONE'
}

export enum TransactionType {
  OfferToSell = 'OFFER_TO_SELL',
  RequestToPurchase = 'REQUEST_TO_PURCHASE'
}

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']>;
  /** chat alias */
  chatAlias?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  config?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  /** first name */
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invited?: Maybe<Scalars['Boolean']>;
  /** last name */
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** position */
  position?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  tradeNotes?: Maybe<Array<TradeNote>>;
  trades?: Maybe<Array<Trade>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<UserEdge>>;
  pageInfo?: Maybe<UserPageInfo>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<User>;
};

export type UserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** chat alias */
  chatAlias?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompanyInput>;
  config?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  /** first name */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invited?: InputMaybe<Scalars['Boolean']>;
  /** last name */
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<NotificationInput>>;
  /** Password */
  password?: InputMaybe<Scalars['String']>;
  /** position */
  position?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  setupKc?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserListResponse = {
  __typename?: 'UserListResponse';
  data: Array<User>;
  pageData?: Maybe<PageData>;
};

export type UserPageInfo = {
  __typename?: 'UserPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type UserRelayResponse = {
  __typename?: 'UserRelayResponse';
  page: UserConnection;
  pageData?: Maybe<PageData>;
};
